var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen"},[_c('div',{staticClass:"z-30 relative"},[_c('MainHeader'),_c('MainMenuTitle'),_c('MainFooter')],1),_c('Background',{staticClass:"z-0",attrs:{"adapt":_vm.w,"colour":_vm.randomColour,"stripes":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }